const type = 'SET_MODAL_CALENDAR';

const setModalCalendar = (data) => ({
  data,
  type,
});

export { type };
export default setModalCalendar;
